import InfoIcon from '@clearkit/icons/glyphs/Info';
import moment from 'moment';

import LoadingBar from '~/components/LoadingBar';
import Spinner from '~/images/shared/Spinner';
import {
  configurationNameForType,
  connectorStatuses,
} from '~/lib/configuration';

import styles from './styles';

const AccountConnectorSyncStatus = ({
  classes,
  accountConnector,
  className,
}) => {
  const remoteMeta = accountConnector?.remoteMeta;

  if (!remoteMeta) {
    return null;
  }

  const syncStatus = remoteMeta?.syncStatus;
  const isErrored = connectorStatuses.error === accountConnector.status;
  const isDisconnected =
    connectorStatuses.disconnected === accountConnector.status;
  const nextSyncAt = moment(remoteMeta?.nextSyncAt);
  const lastSyncAt = moment(remoteMeta?.lastSyncAt);
  const syncProgress = remoteMeta?.syncProgress;

  return (
    <div className={className}>
      <div className={classnames(classes.syncDetail)}>
        {(() => {
          if (isDisconnected) {
            return (
              <>
                <InfoIcon className="mr-2 text-gray-500" />
                <p className={classes.syncState}>
                  {lastSyncAt && (
                    <>
                      Last sync completed {lastSyncAt.fromNow()}
                      <span className={classes.bullet}>∙</span>
                    </>
                  )}
                  Reconnect{' '}
                  {configurationNameForType(accountConnector?.service)} to sync
                  again.
                </p>
              </>
            );
          }

          if (isErrored || syncStatus === 'error') {
            return (
              <>
                <InfoIcon className="mr-2 text-gray-500" />
                <p className={classes.syncState}>
                  Unable to sync{' '}
                  {configurationNameForType(accountConnector?.service)} data
                </p>
              </>
            );
          }

          return (
            <>
              {syncStatus === 'success' && (
                <>
                  <InfoIcon className="mr-2 text-gray-500" />
                  <p className={classes.syncState}>
                    Last sync completed {lastSyncAt.fromNow()}
                    {nextSyncAt > moment.now() && (
                      <>
                        <span className={classes.bullet}>∙</span>
                        <span>Next sync {nextSyncAt.fromNow()}</span>
                      </>
                    )}
                    .
                  </p>
                </>
              )}
              {syncStatus === 'syncing' && typeof syncProgress !== 'undefined' && (
                <>
                  <LoadingBar
                    className={classes.loadingBar}
                    currentPercentage={syncProgress}
                    speed="fast"
                  />
                  <p className={classes.syncState}>
                    Sync {syncProgress + '%'} complete
                    <span className={classes.bullet}>∙</span>This may take a few
                    hours
                  </p>
                </>
              )}
              {!syncStatus && (
                <>
                  <Spinner className={classes.circularLoader} />
                  <p className={classes.syncState}>Starting sync</p>
                </>
              )}
            </>
          );
        })()}
      </div>
    </div>
  );
};

AccountConnectorSyncStatus.propTypes = {
  accountConnector: PropTypes.object.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(styles)(AccountConnectorSyncStatus);
